import { IonApp, setupIonicReact, isPlatform } from "@ionic/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory  } from "react-router-dom";
import { useAppSelector } from "./hooks"; 
import image from "./assets/images/calling_user_minimizer.jpg"
import { setMaxmize } from "./redux/action";
import Routes from "./routes";
import { IonReactRouter } from "@ionic/react-router";
import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "./theme/variables.css";

setupIonicReact();

const App: React.FC = () => {
    const dispatch = useDispatch();
     const history = useHistory();  
    const isMinimized = useAppSelector((state) => state.meeting?.isMinimized);
     const liveMeeting = useAppSelector((state) => state.user.meeting);
    const states = useAppSelector((state) => state);
  console.log(states,'states')
  useEffect(() => {
    redirectToAppropriateView();
  }, []);

  const redirectToAppropriateView = () => {
    if (isPlatform("mobile")) {
    } else {
      window.location.href = "https://web.we2call.com";
    }
  };

    const handleMinimizedImageClick = () => {
    // Replace with actual meeting ID if necessary
    const meetingId = liveMeeting?.meeting_id;
     window.location.href = `https://we2call.com/group-call/${meetingId}`; 
    dispatch(setMaxmize());
  };

  return (
    <>
    {isPlatform("mobile") && !isMinimized ?  (
      <IonApp>
      <IonReactRouter>
        <Routes />
      </IonReactRouter>
    </IonApp>
    ) : (
      <div>
          
          {isMinimized && (
            <div
              className="minimized-meeting-icon"
              onClick={handleMinimizedImageClick}
            >
              <img
                src={image} 
                alt="Minimized Meeting"
                style={{
                  width: "80px",
                  position: "fixed",
                  bottom: "60px",
                  right: "0px",
                  cursor: "pointer",
                  zIndex: 1000,
                }}
              />
            </div>
          )}

          <IonReactRouter>
            <Routes />
          </IonReactRouter>
        </div>
    )}
    </>
  );
};

export default App;
